import { render, staticRenderFns } from "./transferInto.vue?vue&type=template&id=0b47b5fd&scoped=true&"
import script from "./transferInto.vue?vue&type=script&lang=js&"
export * from "./transferInto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b47b5fd",
  null
  
)

export default component.exports